// CODE GENERATED by scripts/gen-perms.mjs. DO NOT EDIT.
// Source of truth: backend internal/authz registry.
export const PERMS = {
  ANALYTICS_READ: "analytics:read",
  AUTHZ_PERMISSION_READ: "authz:permission:read",
  AUTHZ_ROLE_DELETE: "authz:role:delete",
  AUTHZ_ROLE_READ: "authz:role:read",
  AUTHZ_ROLE_WRITE: "authz:role:write",
  CORE_READ: "core:read",
  CORE_WRITE: "core:write",
  CUSTOMER_READ: "customer:read",
  CUSTOMER_WRITE: "customer:write",
  FEEDBACK_READ: "feedback:read",
  MARKETING_READ: "marketing:read",
  MARKETING_WRITE: "marketing:write",
  MENU_READ: "menu:read",
  MENU_WRITE: "menu:write",
  REPORT_READ: "report:read",
  REPORT_WRITE: "report:write",
  SETTINGS_READ: "settings:read",
  SETTINGS_WRITE: "settings:write",
  USER_READ: "user:read",
  USER_WRITE: "user:write",
  VERITECH_READ: "veritech:read",
  VERITECH_WRITE: "veritech:write",
} as const;

export type PermCode = (typeof PERMS)[keyof typeof PERMS];

export const PERM_NAMES: Record<string, string> = {
  "analytics:read": "Аналитик харах",
  "authz:permission:read": "Эрхийн жагсаалт харах",
  "authz:role:read": "Үүрэг харах",
  "authz:role:write": "Үүрэг үүсгэх/засах",
  "authz:role:delete": "Үүрэг устгах",
  "core:read": "Үндсэн харах",
  "core:write": "Үндсэн үйлдэл (үүсгэх/засах/устгах)",
  "customer:read": "Хэрэглэгч харах",
  "customer:write": "Хэрэглэгчийн үйлдэл (үүсгэх/засах/устгах/илгээх)",
  "feedback:read": "Санал хүсэлт харах",
  "marketing:read": "Маркетинг харах",
  "marketing:write": "Маркетингийн үйлдэл (үүсгэх/засах/устгах)",
  "menu:read": "Цэс харах",
  "menu:write": "Цэсний үйлдэл (үүсгэх/засах/устгах)",
  "report:read": "Тайлан харах",
  "report:write": "Тайлангийн үйлдэл (буцаах/түгжих/шинэчлэх)",
  "settings:read": "Тохиргоо харах",
  "settings:write": "Тохиргоо засах",
  "user:read": "Хэрэглэгч/байгууллага харах",
  "user:write": "Хэрэглэгч/байгууллага үйлдэл",
  "veritech:read": "Веритек харах",
  "veritech:write": "Веритек үйлдэл (илгээх/үүсгэх)",
};

export const DOMAIN_LABELS: Record<string, string> = {
  analytics: "Аналитик",
  authz: "Эрхийн удирдлага",
  core: "Машин/Үндсэн",
  customer: "Хэрэглэгч",
  feedback: "Санал хүсэлт",
  marketing: "Маркетинг",
  menu: "Цэс",
  report: "Тайлан",
  settings: "Тохиргоо",
  user: "Хэрэглэгч/Байгууллага",
  veritech: "Веритек",
};

export const permName = (code: string): string => PERM_NAMES[code] ?? code;
export const domainLabel = (domain: string): string => DOMAIN_LABELS[domain] ?? domain;
